import { type RouteObject } from 'react-router';

import { Path } from '../../assets/enums';
import { DrivingRangeSetupRedirect } from './DrivingRangeSetupRedirect.tsx';
import { lazyNamedPage, renderLazyPage } from './lazy-page';

const HomePage = lazyNamedPage(() => import('@pages/home/HomePage.tsx'), 'HomePage');
const CouponsPage = lazyNamedPage(() => import('@pages/coupons/CouponsPage.tsx'), 'CouponsPage');
const CouponPage = lazyNamedPage(() => import('@pages/coupons/CouponPage.tsx'), 'CouponPage');
const CouponsListPage = lazyNamedPage(
  () => import('@pages/coupons/CouponsPage.tsx'),
  'CouponsListPage'
);
const AddCouponPage = lazyNamedPage(
  () => import('@pages/coupons/CouponsPage.tsx'),
  'AddCouponPage'
);
const EditCouponPage = lazyNamedPage(
  () => import('@pages/coupons/CouponPage.tsx'),
  'EditCouponPage'
);
const DeactivateCouponPage = lazyNamedPage(
  () => import('@pages/coupons/CouponPage.tsx'),
  'DeactivateCouponPage'
);
const ActivateCouponPage = lazyNamedPage(
  () => import('@pages/coupons/CouponPage.tsx'),
  'ActivateCouponPage'
);
const ProfilePage = lazyNamedPage(() => import('@pages/profile/ProfilePage.tsx'), 'ProfilePage');
const PartnersPage = lazyNamedPage(
  () => import('@pages/partners/PartnersPage.tsx'),
  'PartnersPage'
);
const PerformancePage = lazyNamedPage(
  () => import('@pages/performance/PerformancePage.tsx'),
  'PerformancePage'
);
const CoursesPage = lazyNamedPage(() => import('@pages/courses/CoursesPage.tsx'), 'CoursesPage');
const PlayersPage = lazyNamedPage(() => import('@pages/players/PlayersPage.tsx'), 'PlayersPage');
const PlayerPage = lazyNamedPage(() => import('@pages/player/PlayerPage.tsx'), 'PlayerPage');
const GameplayPage = lazyNamedPage(
  () => import('@pages/gameplay/GameplayPage.tsx'),
  'GameplayPage'
);
const GameInfoPage = lazyNamedPage(
  () => import('@pages/game-info/GameInfoPage.tsx'),
  'GameInfoPage'
);
const PartnerPage = lazyNamedPage(() => import('@pages/partner/PartnerPage.tsx'), 'PartnerPage');
const CoursePage = lazyNamedPage(() => import('@pages/course/CoursePage.tsx'), 'CoursePage');
const HolePage = lazyNamedPage(() => import('@pages/hole/HolePage.tsx'), 'HolePage');
const UsersPage = lazyNamedPage(() => import('@pages/users/UsersPage.tsx'), 'UsersPage');
const UserPage = lazyNamedPage(() => import('@pages/users/UserPage.tsx'), 'UserPage');
const DevicesPage = lazyNamedPage(() => import('@pages/devices/DevicesPage.tsx'), 'DevicesPage');
const DevicePage = lazyNamedPage(() => import('@pages/device/DevicePage.tsx'), 'DevicePage');
const EditPartnerPage = lazyNamedPage(
  () => import('@pages/partner/EditPartnerPage.tsx'),
  'EditPartnerPage'
);
const SearchCoursePage = lazyNamedPage(
  () => import('@pages/add-course/SearchCoursePage.tsx'),
  'SearchCoursePage'
);
const AddCoursePage = lazyNamedPage(
  () => import('@pages/add-course/AddCoursePage.tsx'),
  'AddCoursePage'
);
const EditCoursePage = lazyNamedPage(
  () => import('@pages/course/EditCoursePage.tsx'),
  'EditCoursePage'
);

export const privateRoutes: RouteObject[] = [
  { path: Path.Coupons, element: renderLazyPage(<CouponsPage />) },
  { path: Path.CouponsList, element: renderLazyPage(<CouponsListPage />) },
  { path: Path.AddCoupon, element: renderLazyPage(<AddCouponPage />) },
  { path: Path.Coupon, element: renderLazyPage(<CouponPage />) },
  { path: Path.EditCoupon, element: renderLazyPage(<EditCouponPage />) },
  { path: Path.DeactivateCoupon, element: renderLazyPage(<DeactivateCouponPage />) },
  { path: Path.ActivateCoupon, element: renderLazyPage(<ActivateCouponPage />) },
  { path: Path.Home, element: renderLazyPage(<HomePage />) },
  { path: Path.Profile, element: renderLazyPage(<ProfilePage />) },
  { path: Path.Partners, element: renderLazyPage(<PartnersPage />) },
  { path: Path.Performance, element: renderLazyPage(<PerformancePage />) },
  { path: Path.Courses, element: renderLazyPage(<CoursesPage />) },
  { path: Path.Players, element: renderLazyPage(<PlayersPage />) },
  { path: Path.Player, element: renderLazyPage(<PlayerPage />) },
  { path: Path.Gameplay, element: renderLazyPage(<GameplayPage />) },
  { path: Path.GameInfo, element: renderLazyPage(<GameInfoPage />) },
  { path: Path.Partner, element: renderLazyPage(<PartnerPage />) },
  { path: Path.Course, element: renderLazyPage(<CoursePage />) },
  { path: `${Path.DrivingRangeSetup}/*`, element: <DrivingRangeSetupRedirect /> },
  { path: Path.Hole, element: renderLazyPage(<HolePage />) },
  { path: Path.Users, element: renderLazyPage(<UsersPage />) },
  { path: Path.User, element: renderLazyPage(<UserPage />) },
  { path: Path.Devices, element: renderLazyPage(<DevicesPage />) },
  { path: Path.Device, element: renderLazyPage(<DevicePage />) },
  { path: Path.AddPartner, element: renderLazyPage(<EditPartnerPage />) },
  { path: Path.EditPartner, element: renderLazyPage(<EditPartnerPage />) },
  { path: Path.SearchCourse, element: renderLazyPage(<SearchCoursePage />) },
  { path: Path.AddCourse, element: renderLazyPage(<AddCoursePage />) },
  { path: Path.EditCourse, element: renderLazyPage(<EditCoursePage />) },
];
